import {
  computePercentAxisMax,
  formatCountAxis,
  formatPercentAxis,
  getCurrencyStringTitleForChart,
} from '@/utils/charts/axisFormatters';
import type { HorizontalBarDatum, ValueMode } from '../types';

export const resolveDataKey = (mode: ValueMode): 'percentValue' | 'rawValue' =>
  mode === 'percent' ? 'percentValue' : 'rawValue';

export const buildValueFormatter = (
  mode: ValueMode,
): ((value: number) => string) => {
  if (mode === 'percent') return formatPercentAxis;
  if (mode === 'count') return formatCountAxis;
  return getCurrencyStringTitleForChart;
};

export const computeAxisMax = (
  data: readonly HorizontalBarDatum[],
  mode: ValueMode,
): number | undefined => {
  if (mode !== 'percent') return undefined;
  return computePercentAxisMax(data.map((d) => d.percentValue));
};

export const computeAxisMin = (mode: ValueMode): number | undefined => {
  if (mode !== 'percent') return undefined;
  return 0;
};
